<template>
  <v-container fluid pa-0 ma-0>
    <v-title>Company</v-title>
    <v-card>
      <v-card-text>
        <v-container grid-list-md>
          <v-flex xs7 offset-xs5 offset-md10 offset-lg10></v-flex>
          <hr />
          <ValidationObserver ref="observer" v-slot="{ dirty, invalid }">
            <v-form v-model="valid">
              <v-layout wrap>
                <v-flex xs12 class="mb-0">
                  <v-radio-group
                    v-if="rows[0].isQuote || isQuote"
                    v-model="inputType"
                    hide-details
                  >
                    <v-radio label="Provide ABN" value="abn"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 sm3 class="pt-0">
                  <vonex-text
                    ref="ABN"
                    v-model="abn"
                    name="ABN"
                    hint="ABN"
                    label="Enter Valid ABN to retrieve business entity"
                    :options="fieldConditions"
                    :rule="inputType === 'company' ? '' : `required|numeric`"
                    :disabled="
                      inputType === 'company' ||
                      (isExistingCustomer &&
                        company.company.abnLookupResponse != null)
                    "
                  ></vonex-text>
                </v-flex>
                <v-flex v-if="monthsOld" xs2>
                  Months Trading: {{ monthsOld }}
                </v-flex>
                <v-alert
                  type="warning"
                  :value="isQantas && monthsOld < 24 && monthsOld > 0"
                >
                  Please note: Company has been trading for
                  {{ monthsOld }} months. Finance is unlikely to be approved for
                  a company that has been trading for less than 2 years.
                </v-alert>
                <v-flex sm12 md12 lg12>
                  <v-btn
                    offset-md10
                    name="abn"
                    color="primary"
                    :disabled="
                      inputType === 'company' ||
                      (isExistingCustomer &&
                        company.company.abnLookupResponse != null)
                    "
                    @click="GetABNorACNdetails"
                  >
                    Retrieve
                  </v-btn>
                  <v-alert
                    v-if="!(isQuote || rows[0].isQuote)"
                    type="error"
                    :value="ACNinvalid"
                  >
                    ABN {{ !abn ? 'not provided' : 'provided is invalid' }}
                  </v-alert>
                </v-flex>

                <v-flex xs12 class="pb-0 mt-3">
                  <v-radio-group
                    v-if="rows[0].isQuote || isQuote"
                    v-model="inputType"
                    hide-details
                  >
                    <v-radio
                      label="Provide company detail"
                      value="company"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>

                <v-flex sm12 md12 lg12 class="pt-0">
                  <v-layout wrap>
                    <v-flex :class="isUpdatedTradingName ? 'sm12 md4' : 'sm12'">
                      <vonex-text
                        ref="Company Name"
                        v-model="companyName"
                        :label="
                          isUpdatedTradingName
                            ? 'Company Name'
                            : 'Company Name / Trading Name'
                        "
                        name="Company Name"
                        readonly
                        :rule="inputType !== 'abn' ? 'required' : ''"
                        :options="fieldConditions"
                        :disabled="inputType === 'abn'"
                      ></vonex-text>
                    </v-flex>
                    <v-flex v-if="isUpdatedTradingName && !soletrader" sm12 md4>
                      <vonex-text
                        ref="Trading Name"
                        v-model="tradingName"
                        label="Trading Name"
                        name="Trading Name"
                        :rule="isUpdatedTradingName ? 'required' : ''"
                        :options="fieldConditions"
                      ></vonex-text>
                    </v-flex>
                    <v-flex v-if="!soletrader" sm12>
                      <v-layout class="align-end">
                        <vonex-checkbox
                          v-model="isUpdatedTradingName"
                          :input-value="isUpdatedTradingName"
                          data-cy-guarantor
                          hide-details
                          class="shrink mr-2"
                        ></vonex-checkbox>
                        Update Trading Name
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-flex>
                    <v-layout v-if="false" row wrap>
                      <v-flex>
                        <vonex-select
                          ref="Industry"
                          v-model="company.industry"
                          name="Industry"
                          :items="industryTypes"
                          label="Industry"
                          item-text="industryTypeDescription"
                          item-value="qfCode"
                          lazy-valiation="true"
                          :options="fieldConditions"
                          :rule="`required`"
                        ></vonex-select>
                      </v-flex>
                      <v-flex>
                        <vonex-select
                          ref="SubType"
                          v-model="company.subIndustry"
                          name="SubType"
                          :items="
                            industrySubTypes.filter(
                              (x) => x.qfCode == company.industry
                            )
                          "
                          label="Sub Type"
                          item-text="subIndustryDescription"
                          item-value="subIndustry"
                          lazy-valiation="true"
                          :rule="`required`"
                          :options="fieldConditions"
                        ></vonex-select>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-flex>
                <v-flex
                  v-show="abn && (soletrader || otherOrganisation)"
                  id="2B"
                  sm12
                  md12
                  lg12
                >
                  <hr />

                  <v-layout v-show="soletrader" id="soleTrader" wrap>
                    <v-flex sm12 md12 lg12>
                      <h3>Extra Details Required</h3>
                    </v-flex>
                    <v-flex sm6 md6 lg6>
                      <vonex-text
                        ref="Trading Name"
                        v-model="tradingName"
                        label="Trading Name (if applicable)"
                        name="Trading Name"
                        :options="fieldConditions"
                      ></vonex-text>
                    </v-flex>

                    <v-flex sm6 md6 lg6>
                      <vonex-text
                        ref="Given Name"
                        v-model="directorGivenName"
                        label="Director Given Name"
                        name="Given Name"
                        lazy-valiation="true"
                        :rule="isdirectorSurnameRequired ? 'required' : ''"
                        :options="fieldConditions"
                      ></vonex-text>
                    </v-flex>
                    <v-flex sm6 md6 lg6>
                      <vonex-text
                        ref="Director Surname"
                        v-model="directorSurname"
                        label="Director Surname"
                        name="Director Surname"
                        :rule="isdirectorSurnameRequired ? 'required' : ''"
                        :options="fieldConditions"
                      ></vonex-text>
                    </v-flex>

                    <v-flex sm3 md3 lg3>
                      <vonex-text
                        ref="Drivers Licence"
                        v-model="driversLicenseNumber"
                        name="Drivers Licence"
                        label="Drivers Licence Number"
                        :rule="isdirectorSurnameRequired ? 'required' : ''"
                        :options="fieldConditions"
                      ></vonex-text>
                    </v-flex>
                    <v-flex sm3 md3 lg3>
                      <vonex-date
                        id="dob"
                        ref="Date of Birth"
                        v-model="dateOfBirth"
                        class="form-group"
                        name="Date of Birth"
                        label="Date of Birth"
                        editable
                        autocomplete="bday"
                        :options="fieldConditions"
                        :rule="`required`"
                      ></vonex-date>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <div v-show="otherOrganisation" id="Other" class="col-md-6">
                  <v-flex v-show="1 == 2">
                    <label>
                      Registered Business Entity Application (other
                      Organisation)
                    </label>
                    <br />
                    <input
                      ref="otherOrganisation"
                      v-model="otherOrganisation"
                      type="checkbox"
                      name="otherOrganisation"
                    />
                  </v-flex>

                  <v-flex v-show="1 == 2">
                    <label>ABN (if applicable):</label>
                    <input
                      ref="abn"
                      v-model="abn"
                      type="text"
                      class="form-control"
                      name="abn"
                      placeholder="ABN (if applicable)"
                    />
                  </v-flex>
                </div>
                <div v-if="guaranteeAttached" id="2C">
                  <v-flex sm12 md12 lg12>
                    <h4>SECTION 2C: TRUST PARTNERSHIP</h4>
                  </v-flex>
                  <hr />

                  <v-flex sm12 md12 lg12>
                    <vonex-checkbox
                      ref="guaranteeAttached"
                      v-model="guaranteeAttached"
                      name="guaranteeAttached"
                      :input-value="guaranteeAttached"
                      :options="fieldConditions"
                    />
                    <v-text-field label="Personal Guarantee Attached:" />
                    <file-uploader>
                      Please upload signed Personal Guarentee
                    </file-uploader>
                  </v-flex>
                  <v-flex sm6 md6 lg6>
                    <v-text-field>label="Date of Birth"</v-text-field>
                    <vonex-date
                      id="dobconsumer"
                      ref="dobconsumer"
                      v-model="dobConsumer"
                      name="dobconsumer"
                      class="form-control"
                      :rule="guaranteeAttached ? 'required|dateofbirth' : ''"
                      editable
                      :options="fieldConditions"
                    ></vonex-date>
                  </v-flex>
                </div>
                <v-flex sm12 md12 lg12>
                  <v-btn
                    color="primary"
                    :disabled="
                      invalid ||
                      !enableSave ||
                      ACNinvalid ||
                      ((rows[0].isQuote || isQuote) && !companyName) ||
                      (isExistingCustomer && inputType !== 'abn')
                    "
                    @click="createCustomerCompany"
                  >
                    Save & Next
                  </v-btn>
                  <!--errors.any() || !valid-->
                </v-flex>
                <message-alert :component="company.message"></message-alert>
              </v-layout>
            </v-form>
          </ValidationObserver>
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { createNamespacedHelpers, mapGetters } from 'vuex';
const { mapState: mapOrderState } = createNamespacedHelpers(`orders`);
import { mapCompanyFields } from '../store/modules/orders';

const { mapActions: mapCompanyActions, mapGetters: mapCompanyGetters } =
  createNamespacedHelpers(`orders/company`);

const { mapMutations: mapOrderMutations } = createNamespacedHelpers(`orders`);
const { mapGetters: mapFeatureFlagGetters } =
  createNamespacedHelpers(`orders/featureFlag`);

import FileUploader from './FileUploader';
import { mapActions } from 'vuex';
import Utils from '@/mixins/utils.mixin';
export default {
  name: 'CreateCompany',
  components: {
    FileUploader,
  },
  mixins: [Utils],
  data() {
    return {
      valid: false,
      isDataLoading: false,
      isCompleted: false,
      ACNinvalid: false,
      nameRules: [
        (v) => !!v || 'Name is required',
        (v) => v.length <= 10 || 'Name must be less than 10 characters',
      ],
      industryTypes: [],
      industrySubTypes: [],
      isAbnValid: false,
      inputType: 'abn',
      saveData: false,
    };
  },
  methods: {
    ...mapCompanyActions([
      'getCompany',
      'addCompany',
      'updateCompany',
      'resetCompany',
      'validateACN',
      'saveCompanyName',
    ]),
    ...mapActions('orders/qantas', ['getSupportingData']),
    ...mapOrderMutations(['setRequiredFields']),
    createCompanySubmit() {
      let vm = this;
      vm.isDataLoading = true;
      vm.addCompany().then(function (data) {
        if (vm.orderID) vm.$store.dispatch('orders/customer/setCompany', data);
        if (vm.$store.getters['orders/changeLessee/createOnly']) {
          vm.$emit(`continue`);
        } else {
          vm.$router.push('create-customer');
        }
      });
    },
    createCustomerCompany: function () {
      let vm = this;
      vm.$refs.observer.validate().then((result) => {
        if (result) {
          if (vm.companyName) {
            vm.saveCompanyName();
            vm.createCompanySubmit();
            let required = [...vm.required_fields];
            required.splice(
              required.findIndex((x) => x.path[0] === '/create-company'),
              1
            );
            vm.setRequiredFields(required);
            return;
          }
          if (!vm.company.hasOwnProperty('abnLookupResponse')) {
            vm.validateACN()
              .then(function (response) {
                vm.validateCustomerCompany(response);
              })
              .catch(() => {
                vm.ACNinvalid = true;
              });
          } else vm.validateCustomerCompany(vm.company);
        }
      });
    },
    GetACN: function () {
      let vm = this;
      vm.isDataLoading = true;
      vm.validateACN()
        .then(function (response) {
          if (response === 'No ABN Provided') {
            vm.ACNinvalid = true;
            vm.isDataLoading = false;
          } else {
            vm.valid = true;
            vm.ACNinvalid = false;
            vm.isDataLoading = false;
            vm.$refs.observer.validate();
            vm.ACNinvalid = false;
          }
        })
        .catch((err) => {
          if (err === 'No ABN Provided') {
            vm.ACNinvalid = true;
            vm.isDataLoading = false;
          }
        });
    },
    GetABNorACNdetails: function (e) {
      let vm = this;
      // vm.resetForm();
      vm.GetACN();
    },
    resetForm: function () {
      let vm = this;
      vm.resetCompany();
      vm.ACNinvalid = false;
    },
    validateCustomerCompany(company) {
      let vm = this;
      if (
        !company ||
        !company.abn ||
        (!company.acn && !vm.isExistingCustomer)
      ) {
        vm.ACNinvalid = true;
        vm.isDataLoading = false;
      } else {
        vm.valid = true;
        vm.ACNinvalid = false;
        vm.isDataLoading = false;
        vm.$refs.observer.validate();

        if (vm.companyID == 0) {
          vm.isDataLoading = true;
          vm.addCompany().then(function (data) {
            if (vm.$store.getters['orders/changeLessee/createOnly']) {
              vm.$emit(`continue`);
            } else {
              vm.$router.push('create-customer');
            }
          });
        } else {
          vm.createCompanySubmit();
        }

        let required = [...vm.required_fields];
        required.splice(
          required.findIndex((x) => x.path[0] === '/create-company'),
          1
        );

        vm.setRequiredFields(required);
      }
    },
  },
  computed: {
    ...mapCompanyFields([
      'company.companyID',
      'company.companyName',
      'company.tradingName',
      'company.entityType',
      'company.directorSurname',
      'company.abn',
      'company.acn',
      'company.driversLicenseNumber',
      'company.dateOfBirth',
      'company.directorGivenName',
      'company.otherOrganisation',
      'company.guaranteeAttached',
      'company.dobConsumer',
      'company.isdirectorSurnameRequired',
      'company.isdateOfBirthRequired',
      'company.industry',
      'company.subIndustry',
      'company.abn_status_from_date',
      'company.isUpdatedTradingName',
    ]),
    ...mapCompanyGetters(['soletrader', 'monthsOld']),
    ...mapOrderState(['company', 'rows', 'required_fields', 'summary']),
    ...mapGetters('orders', [
      'isQantas',
      'orderID',
      'isQuote',
      'isExistingCustomer',
    ]),
    ...mapFeatureFlagGetters(['allFlags']),
    isTrust() {
      if (this.companyName) {
        var res = this.companyName.toLowerCase().includes('trust');
        return res;
      } else return false;
    },
    enableSave() {
      let vm = this;
      if (vm.inputType === 'abn') return vm.acn !== null;
      else return vm.companyName !== null;
    },
  },
  watch: {
    'errors.items': {
      deep: true,
      handler() {
        if (this.errors.items.length > 0 || !this.valid || !this.abn)
          this.isAbnValid = false;
        else this.isAbnValid = true;
      },
    },
    inputType: function () {
      let vm = this;
      vm.ACNinvalid = false;
      vm.companyName = '';
      vm.$refs.observer.reset();
      vm.resetCompany();
    },
    abn: function (curr) {
      this.abn = curr.replace(/\s/g, '');
    },
    isUpdatedTradingName: function (curr) {
      if (!curr) this.validateACN();
    },
  },
  mounted() {
    let vm = this;
    if (
      vm.rows[0].customerDetails &&
      vm.rows[0].customerDetails.companyID &&
      vm.rows[0].customerDetails.companyID > 0
    )
      try {
        vm.getCompany(vm.rows[0].customerDetails.companyID).then(() => {
          vm.getSupportingData().then((data) => {
            if (data) {
              vm.accountHolders = data.accountHolders;
              vm.company.company.industry = 'Q';
              vm.company.company.subIndustry = 'QA';
              vm.$nextTick(() => {
                if (vm.isExistingCustomer) {
                  if (vm.company.company.abn) {
                    vm.GetABNorACNdetails();
                    if (!vm.summary.reportView.company.customerDetails)
                      vm.validateACN()
                        .then(function (response) {
                          if (response) vm.updateCompany();
                        })
                        .catch(() => {});
                  } else vm.ACNinvalid = true;
                }
              });
            }
          });
        });
      } catch (e) {
        //
      }
  },
};
</script>
